<div class="field row" *ngIf="value != null">
    <label class="field-label" for="residual" translate="residualLabel"></label>
    <span class="field-data qa-residual-value" id="residual">{{value | localeCurrency}}</span>
</div>

